// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "main.v-main[data-v-5e6fcabe]{background-image:url(/login-bg.svg);background-position:50%;background-size:cover}", ""]);
// Exports
module.exports = exports;
